import { EventManagerProvider } from 'common-services/event-manager/hook/use-event-manager';
import { StoreProvider } from 'common-services/store/store-provider';
import { FC } from 'react';
import { AppError } from './app-error';
import { instancesMap as appInstancesMap } from './app-instances-map';

const Market: FC<TimApp.IAppContainerProps> = (props) => {
  const { marketConfiguration } = props;
  const MarketContent =
    appInstancesMap[marketConfiguration.brand || 'toyota'][marketConfiguration.elementType][
      marketConfiguration.country
    ] || AppError;

  return (
    <StoreProvider>
      <EventManagerProvider>
        <MarketContent {...props} isStockCarsSimulator={marketConfiguration.elementType === 'stockCarsSimulator'} />
      </EventManagerProvider>
    </StoreProvider>
  );
};

export default Market;
